import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Collapse = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M40.889.42H3.206C1.503.42 0 1.92 0 3.62v37.5c0 1.8 1.503 3.3 3.207 3.3h37.581c1.804 0 3.207-1.5 3.207-3.2V3.62c.1-1.7-1.403-3.2-3.106-3.2Zm1.102 40.8c0 .6-.501 1.2-1.203 1.2H3.207c-.601 0-1.203-.5-1.203-1.2V3.62c0-.6.501-1.2 1.203-1.2h37.581c.602 0 1.203.5 1.203 1.2v37.6Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m35.778 10.22-7.717 7.7h4.81c.601 0 1.002.5 1.002 1 0 .6-.5 1-1.002 1h-7.316c-.3 0-.5-.1-.701-.3-.2-.2-.3-.5-.3-.7v-7.3c0-.6.5-1 1.001-1 .602 0 1.003.5 1.003 1v4.8l7.716-7.7c.401-.4 1.103-.4 1.504 0 .4.4.4 1 0 1.5ZM19.542 25.92v7.3a1.003 1.003 0 0 1-2.004 0v-4.8l-7.717 7.7c-.4.4-1.102.4-1.503 0-.4-.4-.4-1.1 0-1.5l7.717-7.7h-4.81c-.602 0-1.003-.5-1.003-1 0-.6.501-1 1.002-1h7.316c.3 0 .501.1.702.3.2.2.3.4.3.7Z"
  })));
});
Collapse.displayName = 'Collapse';
Collapse.defaultProps = {
  'aria-label': 'Collapse'
};
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Collapse.js
// module id = 3129
// module chunks = 11